import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent { }



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/app.component.ts